<div class="row">
  <div class="col-md-12">
    <br>
    <div class="titulo">
        Mantenedor Anuncios Login
    </div>
  </div>

  <div class="col-md-12">
    <br>

    <div class="sub-titulo d-flex align-items-center justify-content-between">
      <span class="linea">
        Listado de Anuncios
      </span>

      <div class="d-flex align-items-center">
<!-- Selector de Anuncios -->
        <select
          class="form-control mr-2"
          style="min-width: 260px;"
          [(ngModel)]="selectedTypeSponsor"
          (ngModelChange)="applyFilter()"
        >
          <option [ngValue]="0">Todos</option>
          <option [ngValue]="1">PopUp</option>
          <option [ngValue]="2">Pestaña Inf</option>
          <option [ngValue]="3">Carrusel</option>
 
        </select>

         <!-- Selector de clientes -->
        <select
          class="form-control mr-2"
          style="min-width: 260px;"
          [(ngModel)]="selectedCustomerId"
          (ngModelChange)="applyFilter()"
        >
          <option [ngValue]="null">Todos los clientes</option>
          <option *ngFor="let c of listCustomers" [ngValue]="c.cus_id">
            {{ c.cus_name }}
          </option>
        </select>
          <!-- Selector de perfiles -->
          <select
            class="form-control mr-2"
            style="min-width: 260px;"
            [(ngModel)]="selectedProfileType"
            (ngModelChange)="applyFilter()"
          >
            <option ngValue="all">Todos</option>
            <option ngValue="paciente">Paciente</option>
            <option ngValue="medico">Doctor</option>
            <option ngValue="admin">Administrador</option>
            <option ngValue="contact">Contact</option>
            <option ngValue="coordinador">Coordinador</option>
            <option ngValue="gestion">Gestion</option>
            <option ngValue="customer">Cliente</option>
          </select>

       


        <!-- Botón -->
        <button
          type="button"
          class="btn btn-outline-primary botonListar"
          data-toggle="modal"
          data-target="#crearAuspicio"
        >
          Agregar Anuncio
        </button>
      </div>
    </div>
  </div>


  <div *ngIf="isLoading" class="text-center my-4">
    <div class="loader">
      <div class="loader__figure"></div>
      <p class="loader__label">Medis</p>
    </div>
  </div>

  <div *ngIf="isLoading == false" class="col-md-12">
    <br>
    <table class="table table-bordered">
      <thead style="font-family: Mulish; font-style: normal; font-weight: bold; font-size: 20px; color: #171994; text-align: center; background-color: #e6f0ff;">
        <tr>
          <th>#</th>
          <th>Cliente</th>
          <th>Titulo</th>
          <th>Fechas</th>
          <th>Imagen</th>
          <!-- <th>Link</th> -->
          <th>Perfil</th>
          <th>PopUp</th>
          <th>Pestaña Informativa</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>

      <tbody class="sponsor-tbody">
  <tr
    *ngFor="let sponsor of adsFiltered; let i = index"
    [ngClass]="{
      'row-active': sponsor?.is_active,
      'row-inactive': !sponsor?.is_active
    }"
  >
    <td>{{sponsor.ad_id}}</td>
    <td>{{sponsor.cus_name ? sponsor.cus_name : 'Global'}}</td>
    <td>{{sponsor.title}}</td>
    <td>{{sponsor.desdeFormat}} - {{sponsor.hastaFormat}}</td>
    <td>
      <img *ngIf="sponsor.image_url" class="svgItem" style="width: 70px;"
           [src]="URL_DOCS + sponsor.image_url | safeUrl" />
      <span *ngIf="!sponsor.image_url">Sin Imagen</span>
    </td>
    <td>{{sponsor.profile_type | titlecase}}</td>
    <td>{{sponsor.is_popup ? 'Si' : 'No' }}</td>
    <td>{{sponsor.is_tranversal ? 'Si' : 'No' }}</td>
    <td>{{ sponsor.is_active ? 'Activo' : 'Desactivado' }}</td>
    <td>
      <div class="row justify-content-center m-0">
        <div class="col-12 p-0">
          <span data-toggle="modal" data-target="#editarAuspicio" style="cursor: pointer;" (click)="clickSponsor(sponsor)">
            <mat-icon style="color: #316AD8;">manage_search</mat-icon>
          </span>
        </div>
      </div>
    </td>
  </tr>
</tbody>
    </table>
  </div>

  <div *ngIf="isLoading" class="overlay-cargando">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>


</div>



<!-- modal Crear Auspicio -->
<div class="modal fade" id="crearAuspicio" aria-labelledby="crearAuspicioLabel" aria-hidden="true" #crearAuspicio>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Crear nuevo Auspicio</p>
          <hr class="estiloHrModal">
          <br>
 
          <div class="divBodyModal row">

            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chksIsActive"
                  [(ngModel)]="nuevoAuspicio.is_active"
                >
                <label class="custom-control-label letraNormalModal" for="chksIsActive">
                  <strong>Activar</strong>
                </label>
              </div>
            </div>

            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkIsPopUp"
                  [(ngModel)]="nuevoAuspicio.is_popup"
                  (change)="onTogglePopup()"
                  [disabled]="!!nuevoAuspicio.is_tranversal"
                >
                <label class="custom-control-label letraNormalModal" for="chkIsPopUp">
                  <strong>Es Popup</strong>
                </label>
              </div>
            </div>

            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkIsTransversal"
                  [(ngModel)]="nuevoAuspicio.is_tranversal"
                  (change)="onToggleTransversal()"
                  [disabled]="!!nuevoAuspicio.is_popup"
                >
                <label class="custom-control-label letraNormalModal" for="chkIsTransversal">
                  <strong>Pestaña Informativa</strong>
                </label>
              </div>
            </div>
</div>
<div class="divBodyModal row">
<!-- Global + Cliente -->
            <div class="col-3 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkGlobalAuspicio"
                  [(ngModel)]="nuevoAuspicio.is_global"
                  (change)="onToggleGlobalCrear()"
                />
                <label class="custom-control-label letraNormalModal" for="chkGlobalAuspicio">
                  <strong>Global (para todos los clientes)</strong>
                </label>
              </div>
            </div>

            <div class="col-6 mt-2">
              <p class="letraNormalModal"><strong>Cliente:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="nuevoAuspicio.client_id"
                [disabled]="nuevoAuspicio.is_global"
                [ngClass]="{'is-invalid': erroresAuspicio.client_id}"
              >


                <option [ngValue]="null">Seleccione cliente...</option>
                <option *ngFor="let c of listCustomers" [ngValue]="c.cus_id">
                  {{ c.cus_name }}
                </option>
              </select>

              <div *ngIf="erroresAuspicio.client_id" class="invalid-feedback">
                Debes seleccionar un cliente si el auspicio no es global.
              </div>

              <small *ngIf="nuevoAuspicio.is_global" class="text-muted">
                Al ser global, no se asocia a un cliente específico.
              </small>
            </div>

            <div class="col-3 mt-2">
              <p class="letraNormalModal"><strong>Perfil:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="nuevoAuspicio.profile_type"
                [disabled]="nuevoAuspicio.is_tranversal" >
                <option ngValue="all">Todos</option>
                <option ngValue="paciente">Paciente</option>
                <option ngValue="medico">Doctor</option>
                <option ngValue="admin">Administrador</option>
                <option ngValue="contact">Contact</option>
                <option ngValue="coordinador">Coordinador</option>
                <option ngValue="gestion">Gestion</option>
                <option ngValue="customer">Cliente</option>

              </select>
            </div>

          </div>

          <hr class="estiloHrModal">

          <div class="divBodyModal row">

            <!-- Título -->
            <div class="col-8">
              <p class="letraNormalModal"><strong>Título:</strong></p>
              
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder="Título"
                [(ngModel)]="nuevoAuspicio.title"
                maxlength="50"
                (input)="nuevoAuspicio.title = (nuevoAuspicio.title || '').slice(0, 50)"
                [ngClass]="{'is-invalid': erroresAuspicio.title}"
              >
              <small class="text-muted">
                {{ (nuevoAuspicio.title?.length || 0) }} / 50
              </small>
              <div *ngIf="erroresAuspicio.title" class="invalid-feedback">
                El titulo es Obligatorio
              </div>
            </div>
            

            <!-- Prioridad / Orden -->
            <div class="col-4">
              <p class="letraNormalModal"><strong>Orden / Prioridad:</strong></p>
              <select class="form-control" [(ngModel)]="nuevoAuspicio.priority">
                <option *ngFor="let num of numeros" [value]="num">{{ num }}</option>
              </select>
              <small class="text-muted">Menor prioridad = aparece primero.</small>
            </div>

            <!-- Bajada -->
            <div class="col-12 mt-3">
              <p class="letraNormalModal"><strong>Bajada:</strong></p>
              <textarea
                class="form-control camposModalAgregar"
                placeholder="Bajada"
                [(ngModel)]="nuevoAuspicio.subtitle"
                [ngClass]="{'is-invalid': erroresAuspicio.subtitle}"
                rows="2"
                [attr.maxlength]="maxSubtitleLength"
                (input)="nuevoAuspicio.subtitle = (nuevoAuspicio.subtitle || '').slice(0, maxSubtitleLength)"
              ></textarea>
              <small class="text-muted">
                {{ (nuevoAuspicio.subtitle?.length || 0) }} / {{ maxSubtitleLength }}
              </small>
              <div *ngIf="erroresAuspicio.subtitle" class="invalid-feedback">
                La bajada es obligatoria.
              </div>
            </div>

            <!-- Link (responsive: 12 en móvil, 8 en md+) -->
            <div class="col-12 col-md-8 mt-3">
              <p class="letraNormalModal"><strong>Link:</strong></p>
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder=""
                [(ngModel)]="nuevoAuspicio.link_url"
                [ngClass]="{'is-invalid': erroresAuspicio.link_url}"
              >
            </div>

            <div class="col-12 col-md-4 mt-3">
              <p class="letraNormalModal"><strong>Abrir en:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="nuevoAuspicio.link_target"
              >
                <option value="_blank">Nueva ventana</option>
                <option value="_self">Misma ventana</option>
              </select>
            </div>

            <!-- Imagen (subida) -->
            <div class="col-12 mt-3">
              <p class="letraNormalModal"><strong>Imagen:</strong></p>

              <input
                class="form-control camposModalAgregar"
                type="file"
                accept="image/*"
                (change)="onAuspicioImageSelected($event)"
                [ngClass]="{'is-invalid': erroresAuspicio.image_file}"
              >

              <div *ngIf="erroresAuspicio.image_file" class="invalid-feedback">
                Debes seleccionar una imagen.
              </div>

              <!-- Preview opcional -->
              <div class="mt-2" *ngIf="auspicioImagePreview">
                <p class="letraNormalModal"><strong>Vista previa:</strong></p>
                <img [src]="auspicioImagePreview" style="max-width: 100%; max-height: 180px; border-radius: 8px;">
                <br><br>
                <button class="btn btn-outline-danger" (click)="clearSelectedImage()">Quitar imagen seleccionada</button>
              </div>

              <small class="text-muted">
                Formatos recomendados: JPG/PNG. Tamaño sugerido: &lt; 2MB.
              </small>
            </div>

            <!-- Fechas -->
            <div class="col-6 mt-3">
              <p class="letraNormalModal"><strong>Fecha de inicio:</strong></p>
              <input
                type="date"
                [(ngModel)]="nuevoAuspicio.starts_at"
                class="form-control"
                [ngClass]="{'is-invalid': erroresAuspicio.starts_at}"
              />
              <div *ngIf="erroresAuspicio.starts_at" class="invalid-feedback">
                La fecha de inicio es obligatoria.
              </div>
            </div>

            <div class="col-6 mt-3">
              <p class="letraNormalModal"><strong>Fecha de fin:</strong></p>
              <input
                type="date"
                [(ngModel)]="nuevoAuspicio.ends_at"
                class="form-control"
                [ngClass]="{'is-invalid': erroresAuspicio.ends_at}"
              />
              <div *ngIf="erroresAuspicio.ends_at" class="invalid-feedback">
                La fecha de fin no puede ser menor/igual a la de inicio.
              </div>
            </div>

          </div>

          <hr class="estiloHrModal">

          <div class="container-fluid" style="padding: 10px 10px;align-items:center;text-align: center;">
            <button
              type="button"
              class="primary buttonStyleSecondary"
              (click)="saveAuspicio('insert')"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Guardar</span>
              <span *ngIf="isLoading">Guardando...</span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading && modalActivo === 'crear'" class="overlay-modal">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</div>
<!-- /modal Crear Auspicio -->

<!-- modal Ver/Editar Auspicio -->
<div class="modal fade" id="editarAuspicio" aria-labelledby="editarAuspicioLabel" aria-hidden="true" #editarAuspicio>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Ver / Editar Auspicio</p>
          <hr class="estiloHrModal">
          <br>


          <div class="divBodyModal row">

             <!-- Checks -->
            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkEditIsActive"
                  [(ngModel)]="anuncionSelected.is_active"
                  [disabled]="!isEdit"
                >
                <label class="custom-control-label letraNormalModal" for="chkEditIsActive">
                  <strong>Activar</strong>
                </label>
              </div>
            </div>

            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkEditIsPopUp"
                  [(ngModel)]="anuncionSelected.is_popup"
                  [disabled]="!isEdit || !!anuncionSelected.is_tranversal"
                  (change)="onToggleEditPopup()"
                >
                <label class="custom-control-label letraNormalModal" for="chkEditIsPopUp">
                  <strong>Es Popup</strong>
                </label>
              </div>
            </div>

            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkEditIsTransversal"
                  [(ngModel)]="anuncionSelected.is_tranversal"
                  [disabled]="!isEdit || !!anuncionSelected.is_popup"
                  (change)="onToggleEditTransversal()"
                >
                <label class="custom-control-label letraNormalModal" for="chkEditIsTransversal">
                  <strong>Pestaña Informativa</strong>
                </label>
              </div>
            </div>

            <div class="col-3 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkEditGlobalAuspicio"
                  [(ngModel)]="anuncionSelected.is_global"
                  [disabled]="!isEdit"
                  (change)="onToggleGlobalEditar()"
                />
                <label class="custom-control-label letraNormalModal" for="chkEditGlobalAuspicio">
                  <strong>Global (para todos los clientes)</strong>
                </label>
              </div>
            </div>

            <!-- Cliente -->
            <div class="col-6 mt-2">
              <p class="letraNormalModal"><strong>Cliente:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="anuncionSelected.b2b_id_customer"
                [disabled]="(anuncionSelected.is_global) || !isEdit"
                [ngClass]="{'is-invalid': erroresAuspicio.client_id}"
              >
                <option [ngValue]="null">Seleccione cliente...</option>
                <option *ngFor="let c of listCustomers" [ngValue]="c.cus_id">
                  {{ c.cus_name }}
                </option>
              </select>

              <div *ngIf="erroresAuspicio.client_id" class="invalid-feedback">
                Debes seleccionar un cliente si el auspicio no es global.
              </div>

              <small *ngIf="anuncionSelected.is_global" class="text-muted">
                Al ser global, no se asocia a un cliente específico.
              </small>
            </div>

            <!-- Perfil -->
            <div class="col-3 mt-2">
              <p class="letraNormalModal"><strong>Perfil:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="anuncionSelected.profile_type"
                [disabled]="(!isEdit || anuncionSelected.is_tranversal)" >
                <option ngValue="all">Todos</option>
                <option ngValue="paciente">Paciente</option>
                <option ngValue="medico">Doctor</option>
                <option ngValue="admin">Administrador</option>
                <option ngValue="contact">Contact</option>
                <option ngValue="coordinador">Coordinador</option>
                <option ngValue="gestion">Gestion</option>
                <option ngValue="customer">Cliente</option>
              </select>
            </div>

          </div>

          <hr class="estiloHrModal">

          <div class="divBodyModal row">

            <!-- Título -->
            <div class="col-8">
              <p class="letraNormalModal"><strong>Título:</strong></p>
              <small class="text-muted">
                minimo caracteres 35 / maximo 50
              </small>
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder="Título"
                [(ngModel)]="anuncionSelected.title"
                maxlength="40"
                (input)="anuncionSelected.title = (anuncionSelected.title || '').slice(0, 50)"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': erroresAuspicio.title}"
              >
              <small class="text-muted">
                {{ (anuncionSelected.title?.length || 0) }} / 40
              </small>
              <div *ngIf="erroresAuspicio.title" class="invalid-feedback">
                El titulo es Obligatorio
              </div>
            </div>

            <!-- Prioridad / Orden -->
            <div class="col-4">
              <p class="letraNormalModal"><strong>Orden / Prioridad:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="anuncionSelected.priority"
                [disabled]="!isEdit"
              >
                <option *ngFor="let num of numeros" [value]="num">{{ num }}</option>
              </select>
              <small class="text-muted">Menor prioridad = aparece primero.</small>
            </div>

            <!-- Bajada -->
            <div class="col-12 mt-3" style=" display: flex; flex-direction: column;">
              <p class="letraNormalModal"><strong>Bajada:</strong></p>
              <small class="text-muted">
                minimo caracteres {{ minSubtitleLength }} / maximo {{ maxSubtitleLength }}
              </small>
              <textarea
                class="form-control camposModalAgregar"
                placeholder="Bajada"
                [(ngModel)]="anuncionSelected.subtitle"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': erroresAuspicio.subtitle}"
                rows="2"
                [attr.maxlength]="maxSubtitleLength"
                [attr.minlength]="minSubtitleLength"
                (input)="anuncionSelected.subtitle = (anuncionSelected.subtitle || '').slice(0, maxSubtitleLength)"
              ></textarea>
              <small class="text-muted">
                {{ (anuncionSelected.subtitle?.length || 0) }} / {{ maxSubtitleLength }}
              </small>
              <div *ngIf="erroresAuspicio.subtitle" class="invalid-feedback">
                La bajada es obligatoria.
              </div>
            </div>

            <!-- Link (responsive: 12 en móvil, 8 en md+) -->
            <div class="col-12 col-md-8 mt-3">
              <p class="letraNormalModal"><strong>Link:</strong></p>
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder=""
                [(ngModel)]="anuncionSelected.link_url"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': erroresAuspicio.link_url}"
              >
            </div>

            <!-- target (responsive: 12 en móvil, 4 en md+) -->
            <div class="col-12 col-md-4 mt-3">
              <p class="letraNormalModal"><strong>Abrir en:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="anuncionSelected.link_target"
                [disabled]="!isEdit"
              >
                <option value="_blank">Nueva ventana</option>
                <option value="_self">Misma ventana</option>
              </select>
            </div>

            <!-- Imagen actual + reemplazo -->
            <div class="col-12 mt-3">
              <p class="letraNormalModal"><strong>Imagen:</strong></p>

              <!-- Si ya tienes URL guardada, muéstrala -->
              <div *ngIf="anuncionSelected.image_url " class="mt-2">
                <p class="letraNormalModal"><strong>Imagen actual:</strong></p>
                <img [src]="URL_DOCS + anuncionSelected.image_url" style="max-width: 100%; max-height: 180px; border-radius: 8px;">
              </div>

              <!-- Input file solo editable -->
              <input
                class="form-control camposModalAgregar mt-2"
                type="file"
                accept="image/*"
                (change)="onAuspicioImageSelected($event)"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': erroresAuspicio.image_file}"
              >

              <div *ngIf="erroresAuspicio.image_file" class="invalid-feedback">
                Debes seleccionar una imagen válida.
              </div>

              <!-- Preview nueva -->
              <div class="mt-2" *ngIf="auspicioImagePreview">
                <p class="letraNormalModal"><strong>Vista previa (nueva imagen):</strong></p>
                <img [src]="auspicioImagePreview" style="max-width: 100%; max-height: 180px; border-radius: 8px;">
                <br><br>
                <button
                  class="btn btn-outline-danger"
                  (click)="clearSelectedImage()"
                  [disabled]="!isEdit"
                >
                  Quitar imagen seleccionada
                </button>
              </div>

              <small class="text-muted">
                Formatos recomendados: JPG/PNG. Tamaño sugerido: &lt; 2MB.
              </small>
            </div>

            <!-- Fechas -->
            <div class="col-6 mt-3">
              <p class="letraNormalModal"><strong>Fecha de inicio:</strong></p>
              <input
                type="date"
                [(ngModel)]="anuncionSelected.starts_at2"
                class="form-control"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': erroresAuspicio.starts_at2}"
              />
              <div *ngIf="erroresAuspicio.starts_at2" class="invalid-feedback">
                La fecha de inicio es obligatoria.
              </div>
            </div>

            <div class="col-6 mt-3">
              <p class="letraNormalModal"><strong>Fecha de fin:</strong></p>
              <input
                type="date"
                [(ngModel)]="anuncionSelected.ends_at2"
                class="form-control"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': erroresAuspicio.ends_at2}"
              />
              <div *ngIf="erroresAuspicio.ends_at2" class="invalid-feedback">
                La fecha de fin no puede ser menor/igual a la de inicio.
              </div>
            </div>

          </div>

          <hr class="estiloHrModal">

          <!-- Botones -->
          <div class="container-fluid" style="padding: 10px 10px;align-items:center;text-align: center;">

            <!-- modo ver -->
            <button
              *ngIf="!isEdit"
              type="button"
              class="primary buttonStyleSecondary"
              (click)="isEdit = true"
              [disabled]="isLoading"
            >
              Editar
            </button>

            <!-- modo editar -->
            <button
              *ngIf="isEdit"
              type="button"
              class="primary buttonStyleSecondary"
              (click)="saveAuspicio('update')"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Guardar cambios</span>
              <span *ngIf="isLoading">Guardando...</span>
            </button>

            <button
              type="button"
              class="boton-accion colorLetraVolver ml-2"
              data-dismiss="modal"
              aria-label="Close"
              [disabled]="isLoading"
              (click)="cancelEditSponsor('update')"
            >
              Cerrar
            </button>

          </div>

        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading && modalActivo === 'editar'" class="overlay-modal">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</div>
<!-- /modal Ver/Editar Auspicio -->
